unit UContentList;

interface

uses
  UTransferModel, System.Contnrs, UEssentialHelper, Js;

type
  TContentModel = TTransferModel;

  TContentList = class(TObjectList)
  private
    FOnLoaded: TCallback;
    FOnError: TErrorEvent;
    function GetItem(i: Integer): TContentModel;
    procedure DoError(AMsg: string);
    procedure DoLoaded;
    procedure SetValues(Json: string); overload;
    procedure SetValues(Obj: TJsObject); overload;
    procedure SetOnError(const Value: TErrorEvent);
    procedure SetOnLoaded(const Value: TCallback);
  public
    constructor Create;
    procedure Add(Item: TContentModel);
    procedure GetContent(Url: string; FakNr: string);
    property Items[i: Integer]: TContentModel read GetItem;
    property OnLoaded: TCallback read FOnLoaded write SetOnLoaded;
    property OnError: TErrorEvent read FOnError write SetOnError;
  end;

implementation

uses
  WebLib.Json, WebLib.REST, WebLib.Controls, System.SysUtils;

{ TContentList }

procedure TContentList.Add(Item: TContentModel);
begin
  inherited Add(Item);
end;

constructor TContentList.Create;
begin
  inherited Create;
  Self.OnLoaded := nil;
  Self.OnError := nil;
end;

procedure TContentList.DoError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TContentList.DoLoaded;
begin
  if Assigned(Self.OnLoaded) then
    Self.OnLoaded(Self);
end;

procedure TContentList.GetContent(Url, FakNr: string);
var
  client: TRestClient;
  Obj: TJsonObject;
  helper: string;
  procedure Response(Sender: TObject; aResponse: string);
  var
    jso: TJsObject;
  begin
    if aResponse <> '' then
    begin
      jso := TJsJson.parseObject(aResponse);
      if jso['value'] <> nil then
        Self.SetValues(string(jso['value']));
      Self.DoLoaded;
    end
    else
      Self.DoError('Verbindungsfehler: TAttachmentList.GetContentList');
  end;

  procedure ErrorHandler(Sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(Self, '');
  end;

begin
  Obj := TJsonObject.Create;
  Obj.AddPair('FakNr', FakNr);
  helper := Obj.ToString;
  Obj := TJsonObject.Create;
  Obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  client.HttpsPost(Url + '/AttachmentService/GetContentList',
    'application/json', Obj.ToString);
end;

function TContentList.GetItem(i: Integer): TContentModel;
begin
  Result := inherited GetItem(i) as TContentModel;
end;

procedure TContentList.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TContentList.SetOnLoaded(const Value: TCallback);
begin
  FOnLoaded := Value;
end;

procedure TContentList.SetValues(Obj: TJsObject);
var
  i, count: Integer;
begin
  Self.Clear;
  if Obj['Count'] <> nil then
  begin
    count := StrToInt(string(Obj['Count']));
    for i := 0 to count - 1 do
      if Obj['Item' + IntToStr(i)] <> nil then
        Self.Add(TContentModel.Create(string(Obj['Item' + IntToStr(i)])));
  end;
end;

procedure TContentList.SetValues(Json: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(Json);
  Self.SetValues(Obj);
end;

end.
